// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productInformationStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListProductInformation";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

productInformationStyles.container = {
    gap: 0,
    offsetCss: css`
        height: 100%;
    `,
    css: css`
        height: 100%;
        .bottom-info-section {
            gap: 8px;
        }
    `,
};

productInformationStyles.descriptionStyles = {
    productDetailLink: {
        mergeCss: true,
        typographyProps: {
            size: 14,
            weight: fontConfig.weight.semiBold,
            css: css`
                letter-spacing: 0;
                line-height: 18px;
                margin-bottom: 8px;
            `,
        },
    },
    productDetailDescription: {
        size: 14,
        weight: fontConfig.weight.semiBold,
        css: css`
            letter-spacing: 0;
            line-height: 18px;
            margin-bottom: 8px;
        `,
    },
};

productInformationStyles.priceGridItem = {
    width: 12,
};

productInformationStyles.priceStyles = {
    priceWrapper: {
        css: css`
            ${wrapInContainerStyles}
            line-height:22px;
        `,
    },
};
productInformationStyles.attributesGridItem = {
    width: 12,
    css: css`
        padding-top: 8px;
        &:empty {
            display: none;
        }
    `,
};

productInformationStyles.partNumbersGridItem = {
    width: 12,
    css: css`
        display: grid;
        grid-template-columns: 230px auto;
    `,
};
